// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
import 'snippets/swiper-controls/swiper-control';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_featured-collection.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--featured-collection';
var CAROUSEL_CLASS = 'carousel--featured-collection';
var CAROUSEL_SECTION_SELECTOR = '.featured-collection';
var CAROUSEL_SECTION_CLASS = 'featured-collection';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  // Generate unique class for each collection list slider
  element.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));

  // Generate unique btn classes for slider arrows
  element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index));
  element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index));

  // Generate unique btn classes for swiper pagination
  element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [Navigation, Pagination, A11y, Keyboard],
    slidesPerView: 2,
    spaceBetween: 8,
    observer: true,
    observeParents: true,
    a11y: false,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.

    breakpoints: {
      // when window width is >= 768px
      768: {
        slidesPerView: 4,
        spaceBetween: 12
      },
      1080: {
        slidesPerView: 6,
        spaceBetween: 12
      }
    },
    navigation: {
      nextEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index),
      prevEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index)
    },
    pagination: {
      el: ".".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index),
      type: 'bullets',
      clickable: true
    }
  });
  swiper.slides.forEach(function (slide, index) {
    var slideLink = slide.querySelector('a');
    slideLink.addEventListener('focus', function () {
      swiper.slideTo(index);
    });
  });
});